import React, { Component } from "react";

import background_1 from '../../images/banner/slide-image-1.jpg';
import background_2 from '../../images/banner/p10.jpg';
import background_3 from '../../images/banner/slide-image-2.jpg';
import logo from '../../images/token-best.png';

class Intro extends Component {
    render() {
        return(
            <>
            <section id="home">
                <div class="carousel slide" id="carousel-example-generic" data-ride="carousel">
                    <ol class="carousel-indicators text-center">
                        <li data-target="#carousel-example-generic" data-slide-to="0" class="active"></li>
                        <li data-target="#carousel-example-generic" data-slide-to="1"></li>
                        <li data-target="#carousel-example-generic" data-slide-to="2"></li>
                    </ol>

                    <div class="carousel-inner">

                        <div class="item active">
                            <div class="overlay-slide" style={{backgroundImage: `url(${background_1})`}}>
                            </div>
                            <div class="carousel-caption">
                                <div class="col-sm-6 col-xs-12 text-center" style={{maxWidth: '620px'}}>
                                    <img src={logo} style={{width: '75%'}} class="img-responsive" alt="BEST Emec logo"/>
                                </div>
                                <div class="col-sm-6 col-xs-12">
                                    <h3 class="small"><b>Seven hops to heaven: Czech Brewing Tech</b></h3>
                                    <div class="line"></div>
                                    <br />
						            <div class="green-bar">BEST Course in Summer by<strong> LBG Prague</strong></div>
                                    <br />
                                    <div class="green-bar">When? <strong>19.8. - 28.8. 2022</strong></div>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="overlay-slide" style={{backgroundImage: `url(${background_2})`}}>
                            </div>
                            <div class="carousel-caption">
                                <div class="col-sm-6 col-xs-12 text-center" style={{maxWidth: '620px'}}>
                                    <img src={logo} style={{width: '75%'}} class="img-responsive" alt="BEST Hack Day logo"/>
                                </div>
                                <div class="col-sm-6 col-xs-12">
                                    <h3 class="small"><b>Seven hops to heaven: Czech Brewing Tech</b></h3>
                                    <div class="line"></div>
                                    <br />
						            <div class="green-bar">BEST Course in Summer by<strong> LBG Prague</strong></div>
                                    <br />
                                    <div class="green-bar">When? <strong>19.8. - 28.8. 2022</strong></div>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="overlay-slide" style={{backgroundImage: `url(${background_3})`}}>
                            </div>
                            <div class="carousel-caption">
                                <div class="col-sm-6 col-xs-12 text-center" style={{maxWidth: '620px'}}>
                                    <img src={logo} style={{width: '75%'}} class="img-responsive" alt="BEST Hack Day logo"/>
                                </div>
                                <div class="col-sm-6 col-xs-12">
                                    <h3 class="small"><b>Seven hops to heaven: Czech Brewing Tech</b></h3>
                                    <div class="line"></div>
                                    <br />
						            <div class="green-bar">BEST Course in Summer by<strong> LBG Prague</strong></div>
                                    <br />
                                    <div class="green-bar">When? <strong>19.8. - 28.8. 2022</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="slides-control ">
            <a class="left carousel-control" href="#carousel-example-generic" data-slide="prev">
                <span><i class="fa fa-angle-left"></i></span>
            </a>
            <a class="right carousel-control" href="#carousel-example-generic" data-slide="next">
                <span><i class="fa fa-angle-right"></i></span>
            </a>
        </div>
            </section>
            </>
        );
    }
}

export default Intro;